import { dateParse } from '../../utils';
import { DateTime } from './date-time';
import { AngularInjector } from '../angular';

function z(v) {
    return v > 9 ? v : '0' + v;
}

function getISO8601WeekNumber(/* Date obj*/ date) {
    const checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    const time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1;
}

class YmdApi {
    public get_format_string() {
        return 'yyyy-MM-dd';
    }

    public parse(ymd: string) {
        //string 'YYYY-MM-DD'
        const re = /^(\d\d\d\d)[^\d](\d\d)[^\d](\d\d)$/,
            m = ymd.match(re);

        if (m) {
            return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
        }
    }

    public stringify(dt: Date) {
        //Date obj
        if (dt) {
            return [dt.getFullYear(), z(dt.getMonth() + 1), z(dt.getDate())].join('-');
        } else {
            return '';
        }
    }

    public now() {
        return this.stringify(new Date());
    }
}

const ymdApi = new YmdApi();

class TimeApi {
    public stringify(dt) {
        return [z(dt.getHours()), z(dt.getMinutes()), z(dt.getSeconds())].join(':');
    }

    public stringify_short(dt) {
        return [z(dt.getHours()), z(dt.getMinutes())].join(':');
    }
}

const timeApi = new TimeApi();

class WeekApi {
    public number(dt) {
        return getISO8601WeekNumber(dt);
    }

    public dayno(dt) {
        const ret = dt.getDay();
        return ret == 0 ? 7 : ret;
    }
}

const weekApi = new WeekApi();

class DatetimeApi {
    // str = YYYY-MM-DD HH::mm:SS
    // returns [date, time]
    // date = YYYY-MM-DD, time = HH:mm
    public unpack(str: string) {
        const re = /^(\d\d\d\d)[^\d](\d\d)[^\d](\d\d)[^\d](\d\d)[^\d](\d\d)[^\d](\d\d)$/,
            m = str.match(re);

        if (m) {
            return [[m[1], m[2], m[3]].join('-'), [m[4], m[5]].join(':')];
        }
        return null;
    }

    // date = YYYY-MM-DD, time = HH:mm
    // returns YYYY-MM-DDTHH::mm:SS
    public pack(date, time) {
        let ret = null;
        if (date && time) {
            ret = date + 'T' + time + ':00';
        } else if (date && !time) {
            ret = date + 'T00:00:00';
        }
        return ret;
    }

    public parse(ymd) {
        //string 'YYYY-MM-DDTHH:mm:ss' or 'YYYY-MM-DDTHH:mm'
        let re = /^(\d\d\d\d)[^\d](\d\d)[^\d](\d\d)[^\d](\d\d)[^\d](\d\d)[^\d](\d\d)$/,
            m = ymd.match(re);

        if (m) {
            return new Date(m[1], m[2] - 1, m[3], m[4], m[5], m[6]);
        }

        re = /^(\d\d\d\d)[^\d](\d\d)[^\d](\d\d)[^\d](\d\d)[^\d](\d\d)$/;
        m = ymd.match(re);

        if (m) {
            return new Date(m[1], m[2] - 1, m[3], m[4], m[5], 0);
        }

        return null;
    }

    public stringify(dt: Date) {
        // '2004-03-13T13:13:13'
        return ymdApi.stringify(dt) + 'T' + timeApi.stringify(dt);
    }

    public stringify_short(dt: Date) {
        // '2004-03-13T13:13'
        return ymdApi.stringify(dt) + 'T' + timeApi.stringify_short(dt);
    }
}

const datetimeApi = new DatetimeApi();

export interface IDateUtil {
    ymd: YmdApi;
    time: TimeApi;
    week: WeekApi;
    datetime: DatetimeApi;
    parse: (str: string, format: string) => string;
    stringify: (dt: DateTime, format: string) => string;
}

export const sDateUtil: IDateUtil = {
    ymd: ymdApi,
    time: timeApi,
    week: weekApi,
    datetime: datetimeApi,
    parse: function (str: string, format: string) {
        return String(dateParse(str, format));
    },
    stringify: function (dt: DateTime, format: string) {
        const dateFilter: any = AngularInjector.get('dateFilter');
        return dateFilter(dt, format);
    }
};

/**
 * Gets todays date
 * format YYYY-MM-DD
 */
export function getToday(): string {
    const date = new Date();
    return date.toISOString().split('T')[0];
}
